export const loadEmbedCss = (context) => {
    const { url } = context;
    if (!document.getElementById('logi-embed-style')) {
        const linkElement = document.createElement('link');
        linkElement.id = 'logi-embed-style';
        linkElement.href = `${url}/embed/embed.css`;
        linkElement.type = 'text/css';
        linkElement.rel = 'stylesheet';
        document.head.appendChild(linkElement);
    }
    return context;
};
export const loadCssBundle = (context) => {
    const { serverPath, pageData: { staticResourceVersion }, } = context;
    const composerWebCssPath = `/css/logi-composer-embed.css?v=${staticResourceVersion}`;
    const linkElement = document.createElement('link');
    linkElement.href = `${serverPath}${composerWebCssPath}`;
    linkElement.type = 'text/css';
    linkElement.rel = 'stylesheet';
    document.head.appendChild(linkElement);
    return context;
};
//# sourceMappingURL=css.js.map